import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
import { IoCloseSharp } from "react-icons/io5";
import { FaBars } from "react-icons/fa";
import { HiOutlineGlobeAlt } from "react-icons/hi";

const Header = () => {
  const { t, i18n } = useTranslation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true); // 

  const menuLinks = [
    { name: "home", to: "home" },
    { name: "about", to: "about" },
    { name: "services", to: "services" },
    { name: "projects", to: "projects" },
    { name: "testimonials", to: "testimonials" },
    { name: "contact", to: "contact" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTooltip(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const handleLanguageChange = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";

    setRotate(true);
    setShowTooltip(true);

    setTimeout(() => setRotate(false), 500);
    setTimeout(() => setShowTooltip(false), 3000);
  };

  // 
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => document.body.classList.remove("overflow-hidden");
  }, [menuOpen]);

  // 
  const tooltipText = showTooltip
    ? i18n.language === "ar"
      ? "العربية"
      : "English"
    : i18n.language === "ar"
    ? "العربية"
    : "English";

  return (
    <header className="bg-black/40 py-3 lg:px-[80px] px-7 fixed top-0 left-0 w-full z-50">
      <div className="flex justify-between  items-center">
        {/* Logo */}
        <div className="flex items-center whitespace-nowrap text-themegreen font-bold lg:text-3xl text-xl ">
          {t("shorbagy")} <span className="text-white ml-1">{t("agunce")}</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center">
          <ul className="flex space-x-10 text-lg font-poppins text-white">
            {menuLinks.map((link) => (
              <li key={link.to} className="mx-5">
                <Link
                  to={link.to}
                  smooth
                  duration={500}
                  className={`cursor-pointer ${ 
                    link.name === "home"
                      ? "text-themegreen"
                      : "hover:text-themegreen transition-colors"
                  }`}
                >
                  {t(link.name)}
                </Link>
              </li>
            ))}
          </ul>

          {/* Language Icon (Desktop) */}
          <div className="relative ml-6 mx-2">
            <button
              onClick={handleLanguageChange}
              className={`text-white text-2xl transition-transform duration-500 ${
                rotate ? "rotate-180" : ""
              } hover:text-themegreen`}
            >
              <HiOutlineGlobeAlt />
            </button>

            {showTooltip && (
              <span className="absolute top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-3 py-1 rounded shadow">
                {tooltipText}
              </span>
            )}
          </div>
        </nav>

        {/* Mobile Buttons */}
        <div className="flex items-center space-x-4 md:hidden">
          {/* Language Icon (Mobile) */}
          <div className="relative">
            <button
              onClick={handleLanguageChange}
              className={`text-white text-2xl mx-5 mt-2 transition-transform duration-500 ${
                rotate ? "rotate-180" : ""
              } hover:text-themegreen`}
            >
              <HiOutlineGlobeAlt />
            </button>

            {showTooltip && (
              <span className="absolute top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-3 py-1 rounded shadow">
                {tooltipText}
              </span>
            )}
          </div>

          {/* Hamburger */}
          <button
            className="text-white text-2xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <IoCloseSharp /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-full bg-black text-white transform ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out z-40 flex items-center justify-center`}
      >
        <IoCloseSharp
          className="fixed top-3 right-6 text-3xl cursor-pointer"
          onClick={() => setMenuOpen(false)}
        />

        <ul className="flex flex-col space-y-6 text-2xl text-center font-poppins">
          {menuLinks.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                smooth
                duration={500}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer hover:text-themegreen transition-colors"
              >
                {t(link.name)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;